import { isArray, isObject, isString } from 'lodash';

import { Options } from '..';
import defaultConfig from '../../pffe.config';
import { getAbsolutePath, normalizePath } from './utils';

function normalizeExtensions(extensions: Array<string> | string) {
  if (isArray(extensions)) return (extensions as Array<string>).filter(Boolean);
  if (isString(extensions)) return [extensions as string];
  return [];
}

function normalizeFilter(extensions: Array<string> | string): Array<string> {
  if (isArray(extensions)) return (extensions as Array<string>).filter(Boolean);
  if (isString(extensions)) return [extensions as string];
  return [];
}

function normalizeOptions(options: Options): Options {
  if (!options || !isObject(options)) return defaultConfig;
  const { inputFile, outputFile, extensions, filter, treeshake } = options;
  if (!isString(inputFile)) {
    options.inputFile = normalizePath(getAbsolutePath(defaultConfig.inputFile));
  } else {
    options.inputFile = normalizePath(getAbsolutePath(inputFile));
  }
  if (!isString(outputFile)) {
    options.outputFile = normalizePath(
      getAbsolutePath(defaultConfig.outputFile)
    );
  } else {
    options.outputFile = normalizePath(getAbsolutePath(outputFile));
  }
  if (extensions) {
    options.extensions = normalizeExtensions(extensions);
  }
  if (filter) {
    options.filter = normalizeFilter(filter);
  }
  if (!treeshake) {
    options.treeshake = defaultConfig.treeshake;
  } else {
    options.treeshake = !!treeshake;
  }
  return options;
}
export { normalizeExtensions, normalizeOptions };
